import { Heading } from 'src/components/Heading';
import { useNavigate, useParams } from 'react-router-dom';
import { useWizard, WizardProvider } from './components/wizard/WizardContext';
import { ConfigureAutomation } from './components/wizard/ConfigureAutomation';
import { ConfirmationScreen } from './components/wizard/ConfirmationScreen';
import { withIntegrationApp } from 'src/hocs/withIntegrationApp';

const CallAutomationWizardContent = () => {
  const { currentStep } = useWizard();

  return (
    <>
      <div className="p-6">
        {currentStep === 1 && <ConfigureAutomation />}
        {currentStep === 2 && <ConfirmationScreen />}
      </div>
    </>
  );
};

interface CallAutomationWizardProps {
  editing?: boolean;
}

const CallAutomationWizard = ({
  editing = false,
}: CallAutomationWizardProps) => {
  const navigate = useNavigate();
  const { id: editReferenceId } = useParams();

  return (
    <>
      <Heading
        title={editing ? 'Edit Campaign' : 'New Campaign'}
        subtitle={
          editing ? 'Edit your campaign details' : 'Create a new campaign'
        }
        backAction={() => navigate('/campaigns')}
      />
      <div className="p-4">
        <WizardProvider isEditing={editing} editReferenceId={editReferenceId}>
          <CallAutomationWizardContent />
        </WizardProvider>
      </div>
    </>
  );
};

export default withIntegrationApp(CallAutomationWizard);
